import React, { useEffect, useRef, useState } from 'react'
import { auditCustomer, getAccess, getAllPendingRequest, getData, getDetails, getMe, logout } from '../../api.service/user.service'
import axios, { AxiosError } from 'axios'
import './home.css'
import { AgGridReact } from 'ag-grid-react'
import "ag-grid-community/styles/ag-grid.css";
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { ColDef } from 'ag-grid-community'
import { Box, Button, debounce, Fab, Grid, Typography } from '@mui/material';
import ModalWrapper from '../../widgets/modal/modal'
import AuthUserVerification from '../../pages/authUserVerification'
import { FaClockRotateLeft } from "react-icons/fa6";
import CustomSnackbar from '../../widgets/snackbar/snackbar'
import ViewDetails from '../../pages/viewDetails/viewDetails'
import { Img } from 'react-image';
import { useNavigate } from 'react-router-dom'
import ViewAudit from '../../pages/viewAudit/viewAudit'

interface EmiratesId {
    id: string;
    nationality: string;
    dob: string;
}

interface UserData {
    did: string;
    name: string;
    email: string;
    emirates_id: EmiratesId;
    telephone: string;
    appId: string;
}

interface HomeProps {
    onAudit?: (params: any) => void;
    isAuditData?: boolean

}


const Home = (props: HomeProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [auditData, setAuditData] = useState<any[]>()
    const [autoColumnWidth, setAutoColumnWidth] = useState<number>(200)
    const [isAudit, setIsAudit] = useState<boolean>(false)
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        backgroundColor: ''
    })
    const [userDetails, setUserDetails] = useState<any>();
    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const gridRef = useRef<any>(null);

    const handleScrollToActionColumn = () => {
        if (gridRef.current && gridRef.current.api) {
            gridRef.current.api.ensureColumnVisible('action');
            console.log(gridRef, 'Grid Ref')
        }
    };

    useEffect(() => {
        setIsAudit(props.isAuditData as boolean)
    }, [props.isAuditData])


    const [rowData, setRowData] = useState<UserData[]>([])

    const colDef: ColDef[] = [
        {
            headerName: 'App Id',
            field: 'app_id',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Did',
            field: 'did',
            flex: 1,
            minWidth: 250
        },
        {
            headerName: 'Name',
            field: 'name',
            cellRenderer: (params: any) => {
                return <div className='name-column-container'>{params.data.name}
                    {params.data.vip ? <Img
                        src={`/VipBadge.png`}  // Image from public folder
                        alt={params.data.name}
                        style={{ width: '25px', height: '25px', marginLeft: '0px', transform: 'translateY(5px)' }}
                    /> : null}
                </div>
            },
            minWidth: 250,
            flex: 1
        },
        {
            headerName: 'Gender',
            field: 'gender',
            flex: 1,
            minWidth: 100
        },
        {
            headerName: 'Email',
            field: 'email',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Personal Email',
            field: 'personal_email',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Date of Birth',
            field: 'emirates_id',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.emirates_id.dob}</div>
                </>
            }
        },
        {
            headerName: 'Telephone',
            field: 'telephone',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.country_code}-{params.data.telephone}</div>
                </>
            }
        },
        {
            headerName: 'Account Id',
            field: 'account_id',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Country of Residence',
            field: 'country_of_residence',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Dual Citizenship',
            field: 'dual_citizenship',
            flex: 1,
            minWidth: 200
        },
        {
            headerName: 'Secondary Citizenship Country',
            field: 'secondary_citizenship_country',
            flex: 1,
            minWidth: 225
        },
        {
            headerName: 'Record Id',
            field: 'record_id',
            flex: 1,
            minWidth: 225
        },
        {
            headerName: 'Id',
            field: 'emirates_id',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.emirates_id.id}</div>
                </>
            }
        },
        {
            headerName: 'Expiry Date',
            field: 'expiry_date',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.emirates_id.expiry_date}</div>
                </>
            }
        },
        {
            headerName: 'Status',
            field: 'status',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.emirates_id.status}</div>
                </>
            }
        },
        {
            headerName: 'Visa Type',
            field: 'visa_type',
        },
        {
            headerName: 'Nationality',
            field: 'emirates_id',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.emirates_id.nationality}</div>
                </>
            }
        },
        {
            headerName: 'Passport Number',
            field: 'passport',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.passport.number}</div>
                </>
            }
        },
        {
            headerName: 'Passport Type',
            field: 'passport',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.passport.type}</div>
                </>
            }
        },
        {
            headerName: 'Passport Issue Date',
            field: 'passport',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.passport.issue_date}</div>
                </>
            }
        },
        {
            headerName: 'Passport Expiry Date',
            field: 'passport',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.passport.expiry_date}</div>
                </>
            }
        },
        {
            headerName: 'Passport Issue Place',
            field: 'passport',
            cellRenderer: (params: any) => {
                return <>
                    <div>{params.data.passport.place_of_issue}</div>
                </>
            }
        },
        {
            headerName: 'Action',
            field: 'action',
            minWidth: autoColumnWidth,
            cellRenderer: (params: any) => {
                if (params.data.viewDetails) {
                    setAutoColumnWidth(280)
                    handleScrollToActionColumn()
                }
                return (
                    <div className='button-wrapper'>
                        <Button variant="contained" style={{ height: '30px' }} onClick={() => handleDetails(params)}>Details</Button>
                        <Button variant="contained" style={{ height: '30px' }} onClick={() => handleAudit(params)}>Audit</Button>
                        {
                            !params.data.viewDetails ? null
                                :
                                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '20px' }}><div style={{ color: '#F3BF44', fontWeight: 'bold' }}><FaClockRotateLeft fontSize={11} /> Pending</div></div>
                        }


                    </div >
                );
            }
        }

    ]


    const handleAudit = (params: any) => {
        setIsAudit(true)
        setAuditData(params.data.did)
        if (props.onAudit) {
            props.onAudit({ 'name': params.data.name, 'id': params.data.emirates_id.id, 'audit': true })
        }

    }

    const handleDetails = (params: any) => {
        fetchDetails(params.data)

    }

    const requestAccess = (did: string) => {
        getAccess(did).then((result: any) => { })
    }

    const fetchDetails = (data: any) => {
        getDetails(data.did).then((result: any) => {
            if (!result.data.message) {
                setRowData(prevData =>
                    prevData.map(row =>
                        row.did === data.did ? { ...row, viewDetails: false } : row
                    )
                );
                setUserDetails(result.data);
                handleOpenModal();
            } else {
                requestAccess(data.did)
                setRowData(prevData =>
                    prevData.map(row =>
                        row.did === data.did ? { ...row, viewDetails: true } : row
                    )
                );
                setOpenSnackbar({
                    open: true,
                    message: `${result.data.message} !`,
                    backgroundColor: '#edbb26'
                });
            }
        })

    }

    const handleCloseSnackBar = () => {
        setOpenSnackbar({
            open: false,
            message: '',
            backgroundColor: ''
        })
    }


    useEffect(() => {
        getData().then((result: any) => {
            const updatedData = result.data.map((item: any) => ({
                ...item,
                viewDetails: false
            }));
            setRowData(updatedData)

        }, err => {
            logout();
        })
    }, [])

    return (
        <div style={{ height: '100%' }}>
            <div style={{ height: '100%', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '10px' }}>
                <div className='table-container'>
                    <div className='container-100'>
                        {
                            isAudit ? <ViewAudit data={auditData} /> : <AgGridReact
                                ref={gridRef}
                                className="ag-theme-alpine"
                                rowData={rowData}
                                columnDefs={colDef}
                                rowHeight={40}
                                headerHeight={40}
                                suppressDragLeaveHidesColumns={true}
                            />
                        }
                    </div>

                </div>
            </div>
            <CustomSnackbar data={openSnackbar.open ? openSnackbar : false} onClose={handleCloseSnackBar} />
            <ModalWrapper open={openModal} close={handleCloseModal} children={<ViewDetails onClose={handleCloseModal} data={userDetails} />} />

        </div>
    )
}

export default Home